<template>
   <registration :oldData="mode"/>
</template>

<script>
import registration from './pilgrimRegistration'
export default {
    components:{
        registration
    },
    data() {
        return {
            mode: "yes"
        }
    },

}
</script>